import cx from 'classnames';
import React from 'react';

import * as styles from '../Form.module.css';

const Checkbox = ({
  className = '',
  title,
  items,
  textOption,
}: {
  className?: string;
  title: string;
  items: {
    name: string;
    value: string;
    label: string;
  }[];
  textOption?: boolean;
}) => {
	return (
		<div className={cx(styles.checkboxes, className)}>
			<fieldset>
				<legend className={styles.label}>{title}</legend>
        <div>
          {items.map((i, n) => (
            <div>
              <input 
                key={n++}
                id={`${i.name}-${n}`}
                name={i.name} 
                type="checkbox" 
                value={i.value}
              />
              <label htmlFor={`${i.name}-${n}`} className={styles.label}>{i.label}</label>
            </div>
          ))}
        </div>
      </fieldset>
		</div>
	);
};

export default Checkbox;
